
const Symbol = require('core-js/es6/symbol');

const _ = require('lodash');
const ko = require('knockout');


const name = Symbol('name');
const owner = Symbol('owner');

ko.extenders.debug = function (target, options) {
	if (_.isString(options)) {
		options = { name: options };
	} else if (!_.isPlainObject(options)) {
		options = { owner: options };
	}

	target[name] = options.name;
	target[owner] = options.owner;
};
